export enum RepairStatus {
  Opened = 'opened',
  InProcess = 'in-process',
  Budget = 'budget',
  Finished = 'finished',
  Delivered = 'delivered',
  Canceled = 'canceled',
}
